import styled from 'styled-components';

export const Wrapper = styled.button`
  width: auto;
  border-radius: 30px;
  font-weight: bold;
  font-size: 14px;
  padding: 15px 30px;
  text-transform: uppercase;

  
  ${({ theme, type, color }) => `
    color: ${color};
    background: ${type === 'secondary' ? 'transparent' : theme.primary11};
    border: ${type === 'secondary' ? `1.5px solid ${color}` : 'none'};
  `}

  :hover {
    cursor: pointer;
  }

  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media screen and (max-width: 768px) {
    min-width: 75px;
    min-height: 25px;
    font-size:10px
  }
`